import styled from 'styled-components';

export const Title = styled.div`
    font-size: 120px;
    
    .pedro {
        background-color: aqua;
    }

    &:hover {
        color: red;
    }
`;
